module.exports = __webpack_public_path__ + "static/img/saimenInstallForWin_pic15.7eba77d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForWin/saimenInstallForWin_pic15.png
// module id = 582
// module chunks = 1